// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/body/groupPage.styl
// module id = 430
// module chunks = 0